// startup
// Load entry module
__webpack_require__("./source/appstream/appstream.scss");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./source/appstream/appstream.js");
